import moment from "moment/moment";

export const formatDateForAPI = (date, time = null) => {
  const format = time ? "YYYY-MM-DDT" + time : "YYYY-MM-DDTHH:mm:ss";
  return moment(date).format(format);
};
